import { fabric } from "fabric";


const registeredFonts = new Set();

export  async function embedFont(name, url) {
    if (registeredFonts.has(name)) return;

    try {
      const ext = url.split(".").pop().split("?")[0].toLowerCase();
      const fmt =
        ext === "woff2" ? "woff2" :
        ext === "woff"  ? "woff"  :
        ext === "ttf"   ? "truetype" :
                         "opentype";

     if (true) {
       fabric.fontPaths[name] = url;                            
       registeredFonts.add(name);
       return;
     }
 
    } catch (err) {
      console.warn("embedFont failed for", name, url, err);
    }
  }
